import { getAccessToken } from './customerAuth';

const QUERY_FIRST_LOCATION = `query firstCompanyLocation {
  customer {
    companyContacts(first: 1) {
      nodes {
        company {
          locations(first: 1) {
            nodes { id }
          }
        }
      }
    }
  }
}`;

let endpointPromise = null;

async function discoverEndpoint() {
  const fromSettings = window.customerAccount?.apiEndpoint;
  if (fromSettings && /\/customer\/api\/[^/]+\/graphql$/.test(fromSettings)) {
    return fromSettings;
  }
  try {
    const res = await fetch(`${location.origin}/.well-known/customer-account-api`, {
      headers: { Accept: 'application/json' }
    });
    if (!res.ok) return null;
    const json = await res.json();
    return json?.graphql_api || null;
  } catch (err) {
    console.warn('[CustomerAccount] Failed to discover API endpoint:', err);
    return null;
  }
}

async function getApiEndpoint() {
  if (!endpointPromise) endpointPromise = discoverEndpoint();
  const result = await endpointPromise;
  if (!result) endpointPromise = null;
  return result;
}

export async function fetchFirstCompanyLocationId() {
  const token = await getAccessToken();
  if (!token) return null;
  const endpoint = await getApiEndpoint();
  if (!endpoint) return null;
  try {
    const res = await fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({ query: QUERY_FIRST_LOCATION })
    });
    if (!res.ok) return null;
    const json = await res.json();
    return json?.data?.customer?.companyContacts?.nodes?.[0]?.company?.locations?.nodes?.[0]?.id || null;
  } catch (err) {
    console.warn('[CustomerAccount] Failed to fetch first company location:', err);
    return null;
  }
}
